import { RemoveRoleClaimsType } from "../../types/Role";
import { post } from "../../utils/axios-config";
import { ROLES_REMOVE_CLAIMS } from "../../utils/constants";

export const removeRoleClaims = async (data: RemoveRoleClaimsType) => await post<RemoveRoleClaimsType, string>(ROLES_REMOVE_CLAIMS, data);